import { render, staticRenderFns } from "./JointTable.vue?vue&type=template&id=2282776c"
import script from "./JointTable.vue?vue&type=script&lang=js"
export * from "./JointTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports